export default __webpack_public_path__ + "static/media/pet-protect-copay-active.13a27e32.svg";